
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"25","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8.219 2.805v2.934M16.043 2.805v2.934M3.818 9.74h16.627M20.933 9.164v8.313c0 2.934-1.468 4.89-4.89 4.89H8.217c-3.423 0-4.89-1.956-4.89-4.89V9.164c0-2.935 1.467-4.89 4.89-4.89h7.824c3.423 0 4.89 1.955 4.89 4.89z","stroke":"#C728A4","stroke-width":"1.467","stroke-miterlimit":"10","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M12.126 14.247h.009M8.507 14.247h.009M8.507 17.182h.009","stroke":"#C728A4","stroke-width":"1.956","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    